exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-links[data-v-0460f8ec],.parent-link[data-v-0460f8ec]{color:#191923!important;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;color:inherit;display:block;padding:15px 20px 15px 11px;margin:0;flex-grow:1;flex-basis:10%;font-weight:500;font-size:16px;line-height:21px;font-family:var(--default-regular)}.parent-link span[data-v-0460f8ec]{color:#191923!important}.mb-span[data-v-0460f8ec]{padding-left:23px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0460f8ec","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/HeaderMobMenu/MobileChildMenu.vue
// module id = 493
// module chunks = 1